import { createContext } from "react";

import { FormType } from "@/integrations";

// Some backend-driven form schemas render custom components (e.g. WebhookForm)
// alongside *sibling* fields (e.g. a "hidden" webhookId, a "choice" syncMode)
// in the same flat fields array, rather than nesting them under the custom
// component's own `fields`. Those siblings are dispatched independently by
// FormFactory, so a custom component can't see them via its own props.
//
// This context exposes the full, flattened list of every field in the form
// (populated once by CustomForm) so a custom component can synchronously look
// up a sibling field's server-provided value on its very first render,
// instead of racing react-hook-form's registration of that sibling.
const FormFieldsContext = createContext<FormType[]>([]);

export function FormFieldsProvider({
  fields,
  children,
}: {
  fields: FormType[];
  children: React.ReactNode;
}) {
  return (
    <FormFieldsContext.Provider value={fields}>
      {children}
    </FormFieldsContext.Provider>
  );
}
